import axios from "../../axios";
import { ResponseModel } from "../../models/network/response_model";

import { GET_SERVICE_LIST } from "./serviceTypes";
import { LIST_ALL } from "./serviceUrls";

export default {
  [GET_SERVICE_LIST]({ commit }, params) {
    axios.get(LIST_ALL, {
      params: params
    }).then((response) => {
      let responseModel = new ResponseModel(response);
      commit(GET_SERVICE_LIST, responseModel.result.data)
    });
  },
}
